import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import CommercialSessionLobby from "../components/CommercialSessionLobby";
import { joinCommercialSession } from "../lib/api";
import { getCommercialConnectionByInvite, saveCommercialConnection } from "../lib/commercialSessionStorage";
import PageWrapper from "./PageWrapper";

export default function JoinSessionView() {
  const { inviteCode = "" } = useParams();
  const [pseudonym, setPseudonym] = useState("");
  const [connection, setConnection] = useState(null);
  const [restored, setRestored] = useState(false);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    setConnection(getCommercialConnectionByInvite(inviteCode));
    setRestored(true);
  }, [inviteCode]);

  const joinSession = async (event) => {
    event.preventDefault();
    const cleaned = pseudonym.trim();
    if (!cleaned) {
      toast.error("Choisissez un pseudonyme pour cette partie");
      return;
    }
    setJoining(true);
    try {
      const joined = await joinCommercialSession({ inviteCode, pseudonym: cleaned });
      saveCommercialConnection(joined);
      setConnection(joined);
      toast.success("Vous avez rejoint la partie privée");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Impossible de rejoindre cette partie");
    } finally {
      setJoining(false);
    }
  };

  if (!restored) return <div className="loading-screen"><span className="loading-dot" /></div>;
  if (connection) return <CommercialSessionLobby connection={connection} />;

  return (
    <PageWrapper>
      <div className="commercial-entry" data-testid="join-commercial-session">
        <p className="page-eyebrow">Dualflip · Invitation</p>
        <h1 className="page-title">Rejoindre une partie</h1>
        <p className="commercial-intro">
          Vous rejoignez la session <strong>{inviteCode.toUpperCase()}</strong>. Choisissez votre pseudonyme pour cette partie.
        </p>
        <form className="commercial-entry-card" onSubmit={joinSession}>
          <label htmlFor="commercial-join-pseudonym">Votre pseudonyme</label>
          <input
            id="commercial-join-pseudonym"
            data-testid="commercial-join-pseudonym"
            value={pseudonym}
            onChange={(event) => setPseudonym(event.target.value)}
            maxLength={48}
            placeholder="Ex. Emma"
            autoComplete="nickname"
          />
          <button className="btn-primary" type="submit" disabled={joining} data-testid="commercial-join-submit">
            {joining ? "Connexion…" : "Rejoindre la partie"}
          </button>
        </form>
      </div>
    </PageWrapper>
  );
}
